import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Button, SelectChangeEvent } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Formik } from "formik";
import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FormControl from "@mui/material/FormControl";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import {
  Filter,
  GetPaymentHistoryRequest,
  GetPaymentHistoryResponse,
} from "../../models/supplierPayment.model";
import {
  ExportGetRegisterLoans,
  GetRegisterLoans,
} from "../../services/cartable.service";
import {
  FilterFinder,
  GetCustomerRegistrationInfoRequest,
  GetLoanDetailResponse,
  GetLoanRegistrationWizardInfoResponse,
  GetLoansRequest,
  PaginationInfo,
} from "../../models/loan.model";
import { GetStatusResponse } from "../../models/basicInformation.model";
import {
  CURRENT_STATUS_STEPPERCMP,
  CUSTOMER_INFO,
  EXISTING_LOANREQUEST,
  HAS_REGISTER_REQUEST,
  LOAN_ID,
  LOAN_REQUEST_INFO_STEPPERCMP,
  LOAN_REQUEST_SOURCE,
  LOAN_REQUEST_STATUS,
  LOAN_TEMPLATES,
  LOAN_TEMPLATE_INFOS,
  REFRENCE_KEY,
  SUPPLIER_SETTLEMENT_STATUS,
  SUPPLIER_UESR,
  TABLE_FILTER,
  TABLE_FILTER_PAYMENT,
  TABLE_FILTER_REGISTER,
  TABS_STEPPERCMP,
  TEST,
} from "../../config/cacheKey";
import {
  GetLoanRequestSources,
  GetLoanTemplates,
  GetSupplierSettlementStatus,
  GetSupplierUsers,
  getLoanRequestStatus,
} from "../../services/basicInformation.service";
import {
  getCustomerRegistrationInfo,
  getLoanRegistrationWizardInfo,
} from "../../services/loan.service";
import ChipCmp from "../../components/chip/chipCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import { GetPaymentHistory } from "../../services/supplierPayment.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);
let muiSelected: any;
const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "supplierUser", label: "کاربر درخواست دهنده" },
  { id: "requestDate_Persian", label: "تاریخ درخواست" },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "settlementDate_Persian",
    label: "تاریخ تسویه",
  },
  {
    id: "supplierIban",
    label: "شماره شبا ",
  },
  {
    id: "description",
    label: "توضیحات",
  },
];
export default function SettlementPaymentTableCmp(props: any) {
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();
  const ExportGetRegisterLoansMutation = useMutation(ExportGetRegisterLoans, {
    onSuccess: () => {},
  });
  const jsonFile = useSelector((state: any) => state.style);
  muiSelected = jsonFile?.muiSelected;
  let row: any;
  const queryClient = useQueryClient();
  const classes = useStyles();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const oldPage = queryClient.getQueryData<FilterFinder>(TABLE_FILTER_PAYMENT);
  const [isExpanded, setExpanded] = useState(true);
  const [valueRequestDate, setValueRequestDate] = useState<string>();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const [data, setData] = React.useState<GetPaymentHistoryResponse[]>([]);
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );
  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [requestDate, setRequestDate] = React.useState<
    Date[] | null | undefined
  >(null);

  React.useEffect(() => {
    if (props.exportExcel === true) {
      // ExportGetRegisterLoansMutation.mutate(
      //     valueFilterData! ? valueFilterData! : new Filter()
      // );
      props.setExportExcel(false);
    }
  }, [props.exportExcel]);
  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_REGISTER);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_REGISTER);
      setSelectedRow(row?.rowNumber);
    }
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueFilterData(filterData);
        if (props.exportExcel == true) {
          // ExportGetRegisterLoansMutation.mutate(valueFilterData!);
        }
      }
    } else {
      filterData = new Filter();
      filterData.fromDate = undefined;
      filterData.toDate = undefined;

      queryClient.setQueryData(TABLE_FILTER, null);
      setValueFilterData(filterData);
    }
    fillData(filterData!);
    if (props.exportExcel == true) {
      // ExportGetRegisterLoansMutation.mutate(valueFilterData!);
    }
  }, []);

  const getPaymentHistoryMutation = useMutation(GetPaymentHistory, {
    onSuccess: (result: ApiResultModel<GetPaymentHistoryResponse[]>) => {
      if (result) {
        setData(result.data);
        setPageInfo(result.pageInfo);
      }
    },
  });

  useQuery<GetStatusResponse[]>(LOAN_REQUEST_STATUS, getLoanRequestStatus, {
    onSuccess(data) {
      setLoanRequestOptions(data);
    },
  });

  const setChildValueRequestDate = (childValues: any) => {
    const selectedItem = "";
    setValueRequestDate(selectedItem);
    setRequestDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter != undefined) {
      tabelFilter!.fromDate = undefined;
      tabelFilter!.toDate = undefined;
    }

    fillData(tabelFilter!);
  };

  // end basic information

  const generateFilter = (filterData: Filter): GetPaymentHistoryRequest => {
    let request = new GetPaymentHistoryRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    getPaymentHistoryMutation.mutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  //aaded go to stepper
  const dispatch = useDispatch();

  const disposeListener = history.listen((navData) => {
    if (
      navData.pathname === "/settlement/settlementHistory" &&
      history.location.state !== undefined &&
      history.location.state.pageNumber!
    ) {
      currentPaginationInfo.pageNumber = history.location.state.pageNumber;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  });

  const handelDetail = (key: string) => {
    window.sessionStorage.setItem("key-tablePaymentRequestInfo", key);
    history.push("/settlement/settlementHistory/paymentRequestInfo");
    // if (registrationRequestId && loanRequestStatus == "Assigned") {
    //handleSelectRow(rowIndex);
    //go to nantional code ......... nabayaddd
    // history.push({
    //   pathname: `/loan/Register`,
    //   state: {
    //     id: requestId,
    //     from: "",
    //     pageNumber: currentPaginationInfo.pageNumber!,
    //     clickOnBack: false,
    //   },
    // });
    // }
    // handleSelectRow(rowIndex);
    // const valuesNationalCode = new GetCustomerRegistrationInfoRequest();
    // valuesNationalCode.nationalCode = nationalCode;
    // queryClient.setQueryData(REFRENCE_KEY, requestId);
    // getCustomerRegistrationInfo(valuesNationalCode).then((data) => {
    //   if (data) {
    //     queryClient.setQueryData(HAS_REGISTER_REQUEST, data.hasRegisterRequest);

    //     queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
    //     queryClient.setQueryData(LOAN_TEMPLATE_INFOS, data.loanTemplateInfos);
    //     queryClient.setQueryData(
    //       EXISTING_LOANREQUEST,
    //       data.existingLoanRequest
    //     );
    //     // setOpen(false);
    //   }
    // });
  };
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_REGISTER
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  };

  function changeValueRequestDate(e: any) {
    setRequestDate(e);
    setValueRequestDate(e.toString().replace(/,/g, " - "));
  }
  function deleteChip() {
    setValueRequestDate("");
    setRequestDate(undefined);
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
    // changePageNumber(1);
  }
  const filter = new Filter();
  // filter.loanRequestStatus = [];
  // filter.supplierSettlementStatus = [];
  // filter.loanTemplateIds = [];
  // filter.loanRequestStatus = [];
  // filter.supplierUserIds = [];

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };

  return (
    <>
      {props.isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              if (
                requestDate != null &&
                (requestDate[0] != undefined || requestDate[1] != undefined)
              ) {
                values.fromDate = convertToLocalDateTime(
                  Number(requestDate[0])
                );
                if (requestDate.length > 1) {
                  values.toDate = convertToLocalDateTime(
                    Number(requestDate[1])
                  );
                } else {
                  values.toDate = convertToLocalDateTime(
                    Number(requestDate[0])
                  );
                }
              } else {
                values.fromDate = undefined;
                values.toDate = undefined;
                // values.requestDate = undefined;
              }
              // values.requestDatePersian = valueRequestDate;
              // values.requestDateArray = requestDate;

              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
              // changePageNumber(1);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12">
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={requestDate}
                        label={"تاریخ ثبت"}
                        onChange={changeValueRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>

                  <div className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter">
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueRequestDate ? (
                  <div className="row tableCMP">
                    <Button
                      onClick={deleteChip}
                      style={{
                        justifyContent: "right",
                        minWidth: "25px",
                        marginRight: "-1vh",
                      }}
                    >
                      <img
                        style={{ height: "24px", width: "24px" }}
                        src="images/RemoveAllFilters.svg"
                      />
                    </Button>
                    <ChipCmp
                      item={valueRequestDate}
                      enamValue={valueRequestDate}
                      index={valueRequestDate?.length}
                      setChildValue={setChildValueRequestDate}
                    />
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}

                {/* <TableCell
                  className="rowTHead colorTitle stickyColO"
                  align="right"
                >
                  <MoreHorizIcon
                    scale="scale(1.8) "
                    style={{ color: "#1D4A87" }}
                  />
                  <span className="colorTitle textFont12 fontWeight">
                    جزئیات
                  </span>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    onClick={() => handelDetail(row.key)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns.map((column) => {
                      const value =
                        row[column.id as keyof GetPaymentHistoryResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    {/* <TableCell
                      className={
                        rowIndex % 2 == 0 ? " stickyColO   " : " stickyColE  "
                      }
                    >
                      <MoreHorizIcon
                        scale="scale(1.8) "
                        className={
                            row.registrationRequestId &&
                                row.loanRequestStatus == "Assigned"
                                ? "colorTitle"
                                : "colorDesaible1"
                        }

                         onClick={() => handelDetail(row.referenceKey)}
                      />
                    </TableCell> */}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <div className="row"></div>
        <Grid container xs={12}>
          <Grid item xs={4}>
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo?.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={4}>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                display: "flex",
                justifyContent: "center !important",
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
                //  button.sele
              }}
              count={Math.ceil(pageInfo?.total / pageInfo?.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </div>
    </>
  );
}
const onKeyDown = (e: any) => {
  e.preventDefault();
};
